export const convertInsuranceFormDataToFormData = ({
  insuranceFormData,
  userId,
  insuranceId,
}) => {
  const {
    groupNumber,
    memberId,
    payerId,
    primarySubscriber,
    isPrimarySubscriber,
  } = insuranceFormData;

  const data = {};

  data['userId'] = userId;
  data['group_number'] = groupNumber || '';
  data['member_id'] = memberId;
  data['payer_id'] = payerId;
  data['is_primary_subscriber'] = isPrimarySubscriber;

  if (insuranceId) {
    data['patientInsuranceId'] = insuranceId;
  }

  if (primarySubscriber && Object.keys(primarySubscriber).length) {
    data['primary_subscriber'] = {
      first_name: primarySubscriber.firstName,
      last_name: primarySubscriber.lastName,
      postal_code: primarySubscriber.postalCode,
      address_1: primarySubscriber.address1,
      address_2: primarySubscriber.address2 || '',
      phone_number: primarySubscriber.phoneNumber,
      gender: primarySubscriber.gender,
      insurance_relation_id: primarySubscriber.insuranceRelationId || '',
      city: primarySubscriber.city,
      state: primarySubscriber.state,
      dob: primarySubscriber.dob,
    };
  } else {
    data['primary_subscriber'] = {};
  }

  return data;
};



// WEBPACK FOOTER //
// ./src/utils/manage-insurances/convert-insurance-form-data-to-form-data.js